import React, { Component } from "react";

import Nprogress from "nprogress";
import ReactPlaceholder from "react-placeholder";
import "nprogress/nprogress.css";

import "react-placeholder/lib/reactPlaceholder.css";
import CircularProgress from "../components/CircularProgress";

type AsyncComponentProps = {
  history: History;
};

type AsyncComponentState = {
  component: any;
};

export default function AsyncComponent(importComponent: Function): any {
  class AsyncFunc extends Component<AsyncComponentProps, AsyncComponentState> {
    private mounted: boolean;

    constructor(props: any) {
      super(props);
      this.state = {
        component: null,
      };
      this.mounted = true;
      Nprogress.start();
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    async componentDidMount() {
      this.mounted = true;
      const { default: Component } = await importComponent();
      Nprogress.done();
      if (this.mounted) {
        this.setState({
          component: <Component {...this.props} />,
        });
      }
    }

    render() {
      let Component = <CircularProgress className="" />;

      if (this.state.component) {
        Component = this.state.component;
      }

      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
